import {produce} from 'immer';
import React, {useMemo} from 'react';

import {PipelineStepDataKind} from 'graphql-client/__generated/graphqlGlobalTypes';
import ExternalFilePaneContent from 'pipelines/files/ExternalFilePaneContent';
import {assertPipelineStepRawDataIsKind} from 'pipelines/PipelineTypes';

import DataViewContext, {useDataViewContext} from './DataViewContext';
import DataViewPane from './DataViewPane';
import getDownloadFileAction from './file-view/getDownloadFileAction';

/**
 * Render view for files.
 *
 * @package
 */
export default function FileView(): JSX.Element {
  const dataViewContextValue = useDataViewContext();
  const {analysisView} = dataViewContextValue;

  const stepOutputReference = analysisView.lineage[analysisView.lineage.length - 1].stepOutputReference!;
  const file = stepOutputReference.outputStepData.rawDatas[stepOutputReference.rawDataIndex!];

  assertPipelineStepRawDataIsKind(file, PipelineStepDataKind.FILE);

  const newDataViewContextValue = useMemo(
    () =>
      produce(dataViewContextValue, (draftContextValue) => {
        draftContextValue.actions.overflowActions.push(getDownloadFileAction(file));
      }),
    [dataViewContextValue, file]
  );

  return (
    <DataViewContext.Provider value={newDataViewContextValue}>
      <DataViewPane>
        <ExternalFilePaneContent scratchFile={file} />
      </DataViewPane>
    </DataViewContext.Provider>
  );
}
